export default "__VITE_ASSET__BWpQBd45__"